import { action } from 'typesafe-actions';

import { IImportTemplate } from 'APIPackage/ImportExportModule/interfaces/IImportTemplate';
import { ExportSimilaritiesListTypesEnum } from 'APIPackage/SimilarityModule/enums/ExportSimilaritiesListTypesEnum';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';

import { ImportActionsEnum } from '../enums/ImportActionsEnum';
import { IImportFilters } from '../interfaces/IImportFilters';
import { IImportDownloadFile } from '../interfaces/IImportDownloadFile';
import { IUploadModalForm } from '../components/UploadModal';
import { IImportRow } from '../interfaces/IImportRow';
import { IPlanTypeWithFederalLaw } from '../interfaces/IPlanTypeWithFederalLaw';

export const importInitPage = () => action(ImportActionsEnum.IMPORT_INIT_PAGE);
export const importGetData = (searchValue = '') => action(ImportActionsEnum.IMPORT_GET_DATA, { searchValue });
export const importSetSearchValue = (value: string) => action(ImportActionsEnum.IMPORT_SET_SEARCH_VALUE, { value });
export const importGetDataNextPage = () => action(ImportActionsEnum.IMPORT_GET_DATA_NEXT_PAGE);
export const importSetData = (data: IImportRow[], page: number, pageCount: number, totalCount: number) =>
  action(ImportActionsEnum.IMPORT_SET_DATA, { data, page, pageCount, totalCount });
export const importSetOrder = (order: string | null) => action(ImportActionsEnum.IMPORT_SET_ORDER, { order });
export const importSetCurrentUser = (isCurrentUser: boolean) =>
  action(ImportActionsEnum.IMPORT_SET_CURRENT_USER, { isCurrentUser });
export const importRemove = (removedIds: number[]) => action(ImportActionsEnum.IMPORT_REMOVE, { removedIds });
export const importSetFilters = (filters: IImportFilters) => action(ImportActionsEnum.IMPORT_SET_FILTERS, { filters });
export const importUploadFile = (id: number, file: File) => action(ImportActionsEnum.IMPORT_UPLOAD_FILE, { id, file });
export const importCreateTemplateWithFile = (values: IUploadModalForm, planId?: number) =>
  action(ImportActionsEnum.IMPORT_CREATE_TEMPLATE_WITH_FILE, { values, planId });
export const importDownloadFileByTemplateId = ({ id, fileName }: IImportDownloadFile) =>
  action(ImportActionsEnum.IMPORT_DOWNLOAD_FILE_BY_TEMPLATE_ID, { id, fileName });
export const importDownloadWarningsFile = ({ id, fileName }: IImportDownloadFile) =>
  action(ImportActionsEnum.IMPORT_DOWNLOAD_WARNINGS_FILE, { id, fileName });
export const importGetTemplate = (planId: number) => action(ImportActionsEnum.IMPORT_GET_TEMPLATE, { planId });
export const importSetTemplate = (template?: IImportTemplate) =>
  action(ImportActionsEnum.IMPORT_SET_TEMPLATE, { template });
export const importSetKnoOrganizationId = (knoOrganizationId: string | undefined) =>
  action(ImportActionsEnum.IMPORT_SET_KNO_ORGANIZATION_ID, { knoOrganizationId });
export const importSetKnoOrganizationErvkId = (knoOrganizationErvkId: string | undefined) =>
  action(ImportActionsEnum.IMPORT_SET_KNO_ORGANIZATION_ERVK_ID, { knoOrganizationErvkId });
export const importSetSupervisionTypeErvkId = (supervisionTypeErvkId: string | undefined) =>
  action(ImportActionsEnum.IMPORT_SET_SUPERVISION_TYPE_ERVK_ID, { supervisionTypeErvkId });
export const importSetKnmTypeId = (knmTypeId: number | undefined) =>
  action(ImportActionsEnum.IMPORT_SET_KNM_TYPE_ID, { knmTypeId });
export const importSetSubjectTypeId = (subjectTypeId: number | undefined) =>
  action(ImportActionsEnum.IMPORT_SET_SUBJECT_TYPE_ID, { subjectTypeId });
export const importSetSubjectTypeErvkId = (subjectTypeErvkId: string | undefined) =>
  action(ImportActionsEnum.IMPORT_SET_SUBJECT_TYPE_ERVK_ID, { subjectTypeErvkId });
export const importResetUploadModalStore = () => action(ImportActionsEnum.IMPORT_RESET_UPLOAD_MODAL_STORE);
export const importExportSimilaritiesListByPlanId = (
  id: string,
  format: ExportFormatsEnum,
  type: ExportSimilaritiesListTypesEnum.KNM_MATCH_BY_PLAN | ExportSimilaritiesListTypesEnum.KNM_MATCH_BY_PLAN_ALL,
) => action(ImportActionsEnum.IMPORT_EXPORT_SIMILARITIES_LIST_BY_PLAN_ID, { id, format, type });
export const importSetPlanTypeWithFederalLaw = (planTypeWithFederalLaw: IPlanTypeWithFederalLaw | undefined) =>
  action(ImportActionsEnum.IMPORT_SET_PLAN_TYPE, { planTypeWithFederalLaw });
export const importSetFederalLaw = (federalLaw: IFederalLawErvk | undefined) =>
  action(ImportActionsEnum.IMPORT_SET_FEDERAL_LAW, { federalLaw });
